"use client";
import { createContext, useContext, useEffect, useState } from "react";
interface SessionToken {
  sessionToken: string | null;
}

const SessionTokenContext = createContext<SessionToken>({
  sessionToken: null,
});

export function getCookie(name: string): string | null {
  if (typeof document === "undefined") return null;

  const cookies = document.cookie.split("; ");

  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split("=");

    if (cookieName === name) {
      return decodeURIComponent(cookieValue!);
    }
  }

  return null;
}

export const SessionTokenProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [sessionToken, setSessionToken] = useState<string | null>(null);

  useEffect(() => {
    const checkSessionCookie = () => {
      const currentSessionToken = getCookie("__session");
      if (currentSessionToken !== sessionToken) {
        setSessionToken(currentSessionToken);
      }
    };

    checkSessionCookie();
    const intervalId = setInterval(checkSessionCookie, 1000); // Check every second

    // Clean up on unmount
    return () => {
      clearInterval(intervalId);
    };
  }, [sessionToken]);

  return (
    <SessionTokenContext.Provider value={{ sessionToken }}>
      {children}
    </SessionTokenContext.Provider>
  );
};

export const useSessionToken = () => {
  const context = useContext(SessionTokenContext);
  if (!context) {
    throw new Error(
      "useSessionToken must be used within a SessionTokenProvider",
    );
  }
  return context;
};
